import React from 'react';
import styled from '@emotion/styled';
import Button from '../buttons/Button';
import colors from '../../theme/colors';
import { FONT_FAMILIES } from '../../theme/material/constants';
import AppleIcon from '../icons/AppleIcon';
import { appleAuth } from '../../utils/appleAuth';
import { APPLE_AUTH } from '../../config/Master';

declare global {
  interface Window {
    AppleID: any;
  }
}

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
export const StyledAppleButton = styled(Button)(() => ({
  background: colors.gray['100'],
  border: `1px solid ${colors.gray['1200']}`,
  borderRadius: '4px',
  fontSize: '14px !important',
  fontWeight: 400,
  fontFamily: FONT_FAMILIES.primary,
  letterSpacing: '-0.3px',
  width: '100%',
  height: 40,
  color: colors.light.gray.light,
}));

interface IAppleButtonProps {
  onAppleConnect: (data: any) => void;
  label?: string;
}

const AppleButton: React.FC<IAppleButtonProps> = ({ label, onAppleConnect }) => {
  const handleAppleLogin = async () => {
    await appleAuth(data => {
      onAppleConnect({ site: APPLE_AUTH, email: data?.user?.email ?? '', token: data?.authorization?.id_token });
    });
  };

  return (
    <StyledAppleButton
      isDefault={true}
      buttonType="default"
      type="button"
      name="commit"
      icon={<AppleIcon />}
      onClick={handleAppleLogin}
    >
      {label ?? 'Continue with Apple'}
    </StyledAppleButton>
  );
};

export default AppleButton;
